import React, { useMemo } from 'react'
import MealIngredientUnitForm from './_form'

export default function MealIngredientUnitAdd (props) {
  const data = useMemo(() => ({ active: false }), [])
  return (
    <MealIngredientUnitForm data={data} {...props} />
  )
}